import OpenPayPeriodText from '@atoms/OpenPayPeriodText';
import TextCurrency from '@atoms/TextCurrency';
import WithdrawError from '@atoms/WithdrawError';
import { View } from '@components/primitives';
import SliderView from '@molecules/SliderView';
import WithdrawButton from '@molecules/WithdrawButton';
import { getStore } from '@store/storeUtils';
import React, { useState } from 'react';

const AccountSlider: React.FC = () => {
  const { selectedAccount } = getStore();

  const { slider, balance, openPeriod, withdrawalButton } = selectedAccount;
  const [editable, setEditable] = useState(false);
  const [focusInputField, setFocusInputField] = useState(false);

  if (slider?.enabled) {
    return (
      <SliderView
        editable={editable}
        setEditable={setEditable}
        focusInputField={focusInputField}
        setFocusInputField={setFocusInputField}
      />
    );
  }

  return (
    <View>
      <TextCurrency amountCurrency={balance} variant="md-bold" />
      <WithdrawButton
        isDisabled={!withdrawalButton?.enabled}
        withdrawalAmount={balance}
        source="home_page"
        transaction_category_id="wd-01"
      />
      <WithdrawError />
      <OpenPayPeriodText openPeriod={openPeriod} />
    </View>
  );
};

export default AccountSlider;
